import image1 from "./assets/images/ice.png";
import image2 from "./assets/images/springs.png";
import image3 from "./assets/images/cat.png";
import image4 from "./assets/images/fl.jpg";
import image5 from "./assets/images/cw.png";
import image6 from "./assets/images/sd.png";
import image7 from "./assets/images/maa.png";

export default [image5, image2, image3, image4, image1, image6, image7];
